import {
  ConsentResponse,
  LegalNoticeResponse,
} from 'services/api/responses/responseTypes';
import type { Nullable } from '../../../types';
import { ISubject } from '../subject';
import { ILegalNotice } from '../legalNotice';
import type { IConsent } from './iConsent';

export default class Consent implements IConsent {
  subject: ISubject;

  legalNotices: Nullable<Array<ILegalNotice>>;

  preferences: {
    general: boolean;
  };

  constructor(
    subject: ISubject,
    preferences: {
      general: boolean;
    },
    legalNotices: Nullable<Array<ILegalNotice>> = null
  ) {
    this.subject = subject;
    this.legalNotices = legalNotices;
    this.preferences = preferences;
  }

  toRequestData(): ConsentResponse {
    const request = {
      preferences: this.preferences,
      subject: this.subject.toRequestData(),
    };
    return this.legalNotices
      ? { ...request, legal_notices: this.legalNoticeRequestData() }
      : request;
  }

  legalNoticeRequestData(): Array<LegalNoticeResponse> {
    const { legalNotices } = this;

    if (!legalNotices) {
      return [];
    }

    return legalNotices.map((notice) => notice.toRequestData());
  }
}
